<template>
  <div id="header">
    <div class="header">
      <div class="logo" @click="goHome">
        <img src="@/assets/images/Header.png" />
      </div>
      <button class="ends" @click="switchs" :flag="false">{{ str }}</button>
    </div>
    <!-- 测试翻译 -->
    <!-- <p>{{$t('common.Sass')}}</p> -->
  </div>
</template>
<script>
  import Bus from '../../bus'
  export default {
    name: 'Header',
    components: {},
    data() {
      return {
        flag: false,
        str: '中文',
      }
    },
    created() {},
    methods: {
      goHome() {
        this.$router.push({
          path: '/home',
        })
      },
      switchs() {
        console.log('123')
        this.flag = !this.flag
        // console.log(this.flag);
        if (this.flag == false) {
          this.str = '中文'
          this.$i18n.locale = 'zh'
        } else {
          this.str = 'English'
          this.$i18n.locale = 'en'
        }
        Bus.$emit('flag', this.flag)
      },
    },
  }
</script>
<style scoped lang="scss">
  #header {
    width: 100%;
    .header {
      padding-right: 50px;

      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        display: block;
        width: 462px;
        height: 115px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .ends {
        display: block;
        width: 100px;
        height: 50px;
        background: rgb(226, 42, 42);
        border: none;
        color: white;
        border-radius: 25px;
      }
    }
  }
</style>
